<!--
  ~ Copyright 2020 Google LLC.
  ~ SPDX-License-Identifier: Apache-2.0
  -->

<div class="tooltip" id="{{tooltip.envName}}"
     *ngIf="isReady()"
     [ngStyle]="{'font-size':fontMultiplier+'vw', 'pointer-events': tooltip.clickOn ? 'all' : 'none'}"
     [innerHTML]="getData()">
</div>
